import React from 'react';
import './Page.css';

const InvestmentRisk = () => {
  return (
    <div className="page-content">
      <div className="container">
        <h1>Investment Risk Notice</h1>
        
        <h2>What are the main risks?</h2>
        
        <div className="risk-cards">
          <div className="risk-card">
            <div className="risk-number">1</div>
            <h3>You could lose all the money you invest</h3>
            <p>Cryptoassets are highly volatile, meaning their value can drop as quickly as it can rise. Be prepared to lose your entire investment.</p>
            <p>Additionally, the cryptoasset market is mostly unregulated, exposing you to risks like cyber-attacks, financial crime, or company failure.</p>
          </div>
          
          <div className="risk-card">
            <div className="risk-number">2</div>
            <h3>You may not be protected if things go wrong</h3>
            <p>This type of investment is not covered by standard deposit insurance schemes because it's not considered a 'specified investment' under Czech regulation. Cryptoasset investments are not protected by the Czech Deposit Insurance Fund.</p>
            <p>For complaints regarding this firm, you may contact the Czech National Bank (Česká národní banka - ČNB), which is the financial market supervisor in the Czech Republic. For more information, visit the ČNB consumer protection section <a href="https://www.cnb.cz/en/supervision-financial-market/consumer-protection-and-financial-literacy/consumer-protection/" target="_blank" rel="noopener noreferrer">here</a>.</p>
          </div>
          
          <div className="risk-card">
            <div className="risk-number">3</div>
            <h3>Don't put all your money in one investment</h3>
            <p>Concentrating your funds in a single investment is risky. Diversifying across different assets can reduce dependence on any one investment's success.</p>
            <p>As a rule, consider limiting high-risk investments to no more than 10% of your total assets.</p>
            <p>For more information on how to protect yourself and learn more about cryptoassets, visit the Czech National Bank (ČNB) website <a href="https://www.cnb.cz/en/supervision-financial-market/consumer-protection-and-financial-literacy/consumer-protection/" target="_blank" rel="noopener noreferrer">here</a>.</p>
          </div>
        </div>
        
        <h2>Different Cryptoasset Risks</h2>
        <p>Discover specific risks associated with different types of cryptoassets <a href="https://www.cnb.cz/en/supervision-financial-market/consumer-protection-and-financial-literacy/consumer-protection/notices-about-activities/Notice-regarding-risks-associated-with-offers-to-the-public-of-crypto-assets/" target="_blank" rel="noopener noreferrer">here</a>.</p>
      </div>
    </div>
  );
};

export default InvestmentRisk;
